/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type GhostUnstakedEvent = { agent: Address; amount: bigint };

export type GhostUnstakedEventArgs = {
  agent: Address;
  amount: number | bigint;
};

export function getGhostUnstakedEventEncoder(): FixedSizeEncoder<GhostUnstakedEventArgs> {
  return getStructEncoder([
    ["agent", getAddressEncoder()],
    ["amount", getU64Encoder()],
  ]);
}

export function getGhostUnstakedEventDecoder(): FixedSizeDecoder<GhostUnstakedEvent> {
  return getStructDecoder([
    ["agent", getAddressDecoder()],
    ["amount", getU64Decoder()],
  ]);
}

export function getGhostUnstakedEventCodec(): FixedSizeCodec<
  GhostUnstakedEventArgs,
  GhostUnstakedEvent
> {
  return combineCodec(
    getGhostUnstakedEventEncoder(),
    getGhostUnstakedEventDecoder(),
  );
}
